import { ConnectionAuthKind } from '../interfaces/IAuthenticationType';
import type { TridentArtifactTypeV2 } from '@trident/data-access-artifact';

export interface ITridentResource {
    workspaceObjectId?: string;
    artifactType?: TridentArtifactTypeV2;
    dataFactoryId?:string;
    description?: string;
    displayName: string;
    extendedProperties?: Record<string, unknown>;
    objectId: string;
    payloadContentType: string;
    workloadPayload: string;
    version?: string;
    // #region DMTS connection only
    clusterId?: string;
    clusterName?: string;
    gatewayType?: FabricGatewayType;
    allowDatasourceThroughGateway?: boolean;
    memberGateways: IMemberGateways;
    datasourceReference?: string;
    connectionDetails?: string;
    credentialDetails?: {
        credentialType: ConnectionAuthKind;
    } & Record<string, string>;
    datasourceName?: string;
    datasourceType?: string;
    // #endregion
    resourceLoadingStatus?: 'Stub';
    parentArtifactObjectId?: string;
    subfolderId?: number;
}

export enum FabricGatewayType {
    Enterprise = 'Enterprise',
    Personal = 'Personal',
    VirtualNetwork = 'VirtualNetwork',
    TenantCloud = 'TenantCloud'
}

export interface IMemberGateways {
    id: string;
    name: string;
    version: string;
    publicKey: string;
    state: 'Enabled' | 'None';
    staticCapabilities: number;
}

export interface IFunctionSetWorkloadPayload {
    functions: IFunctionSetWorkloadPayloadFunction[]
}

export interface IDataflowWorkloadPayload {
    formatVersion: string;
    mappingDataflowContent: string;
    type: string;
    editingSession?: IGen2EditingSession;
}

export interface IGen2EditingSession {
    computeEngineSettings?: Record<string, unknown>;
    editingSessionMashup?: IGen2EditingSessionMashup;
}

export interface IGen2EditingSessionMashup {
    mashupName?: string;
    mashupDocument?: string;
    queryGroups?: unknown[];
    documentLocale?: string;
    queriesMetadata?: Record<string, IGen2QueryMetadata>;
    connectionOverrides?: unknown[];
    useHostConnectionProvider?: boolean;
    fastCombine?: boolean;
    allowNativeQueries?: boolean;
    skipAutomaticTypeAndHeaderDetection?: boolean;
    hostProperties?: Record<string, string>;
}

export interface IGen2QueryMetadata {
    queryId: string;
    queryName: string;
    lastKnownIsCalculatedEntity: boolean;
    lastKnownIsLinkedEntity: boolean;
    lastKnownIsParameter: boolean;
    isHidden: boolean;
    lastKnownResultTypeName: string;
    loadEnabled: boolean;
    fieldsMetadata: Record<string, unknown>;
    deleteExistingDataOnLoad: boolean;
    hostProperties: Record<string, unknown>;
}

export interface IFunctionSetWorkloadPayloadFunction {
    name: string;
    fabricProperties?: IFunctionSetWorkloadPayloadFunctionProperties;
}

export interface IFunctionSetWorkloadPayloadFunctionProperties {
    fabricFunctionParameters?: IFunctionSetWorkloadPayloadFunctionPropertiesParameters[];
}

export interface IFunctionSetWorkloadPayloadFunctionPropertiesParameters {
    dataType: string;
    name: string;
}
